import React, { useState } from 'react';

const ZONES = [
  { key: 'off', label: 'Not charted' },
  { key: 'left', label: 'Left axis · bars' },
  { key: 'right', label: 'Right axis · lines' },
];

// Drag-and-drop chooser for which series a chart shows and on which axis.
// items = [{ key, label, color }]; axes = { left: [keys], right: [keys] } (an
// item on neither is off the chart); onChange(axes). Drag a chip to a zone (or
// onto the chart, via dropOnChart below), or click a chip and then a zone
// (touch / keyboard).
export function moveItem(axes, key, to) {
  const next = { left: axes.left.filter((k) => k !== key), right: axes.right.filter((k) => k !== key) };
  if (to === 'left' || to === 'right') next[to] = [...next[to], key];
  return next;
}

export default function ChartAxes({ items, axes, onChange }) {
  const [picked, setPicked] = useState(null);
  const [over, setOver] = useState(null);
  const zoneOf = (key) => (axes.left.includes(key) ? 'left' : axes.right.includes(key) ? 'right' : 'off');
  const drop = (zone, key) => {
    if (key && items.some((i) => i.key === key)) onChange(moveItem(axes, key, zone));
    setPicked(null);
    setOver(null);
  };
  return (
    <div className="chart-axes">
      {ZONES.map((z) => (
        <div key={z.key}
          className={`chart-axes-zone${over === z.key ? ' over' : ''}${picked ? ' armed' : ''}`}
          onDragOver={(e) => { e.preventDefault(); setOver(z.key); }}
          onDragLeave={() => setOver((o) => (o === z.key ? null : o))}
          onDrop={(e) => { e.preventDefault(); drop(z.key, e.dataTransfer.getData('text/plain')); }}
          onClick={() => picked && drop(z.key, picked)}>
          <span className="chart-axes-label">{z.label}</span>
          {items.filter((i) => zoneOf(i.key) === z.key).map((i) => (
            <button key={i.key} type="button" draggable
              className={`chart-axes-chip${picked === i.key ? ' picked' : ''}`}
              onDragStart={(e) => { e.dataTransfer.setData('text/plain', i.key); e.dataTransfer.effectAllowed = 'move'; }}
              onDragEnd={() => setOver(null)}
              onClick={(e) => { e.stopPropagation(); setPicked((p) => (p === i.key ? null : i.key)); }}
              aria-pressed={picked === i.key}>
              <span className="chart-swatch" style={{ background: i.color }} />{i.label}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}

// Props for a chart wrapper that takes a dragged chip: dropped on the left half
// it goes to the left axis, on the right half to the right axis.
export function dropOnChart(axes, onChange) {
  return {
    onDragOver: (e) => e.preventDefault(),
    onDrop: (e) => {
      e.preventDefault();
      const key = e.dataTransfer.getData('text/plain');
      if (!key) return;
      const box = e.currentTarget.getBoundingClientRect();
      onChange(moveItem(axes, key, e.clientX - box.left < box.width / 2 ? 'left' : 'right'));
    },
  };
}
